<template>
  <span v-if="info" class="stage-badge" :title="info.help"><i class="dot" :style="{backgroundColor: info.color}"></i>{{ info.label }}</span>
  <span v-else-if="importedWithoutStage" class="stage-badge unclassified" :title="help"><i class="dot"></i>{{ label }}</span>
</template>

<script>
import {FUNNEL_STAGE_ENUM, UNCLASSIFIED_HELP, UNCLASSIFIED_LABEL} from "@/marketing/utils";

/**
 * Intention d'un contenu (Se faire connaître / Donner confiance / Convertir), avec la couleur de sa barre de répartition.
 * Sans intention : « À classer » (publication importée d'un réseau) quand `showUnclassified` est demandé, rien sinon.
 */
export default {
  name: 'FunnelStageBadge',
  props: {
    stage: {type: String, default: undefined},
    showUnclassified: {type: Boolean, default: true},
  },
  data() {
    return {label: UNCLASSIFIED_LABEL, help: UNCLASSIFIED_HELP};
  },
  computed: {
    info() {
      return FUNNEL_STAGE_ENUM[this.stage];
    },
    importedWithoutStage() {
      return this.showUnclassified && !this.stage;
    },
  },
};
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

.stage-badge
  display inline-flex
  align-items center
  gap 6px
  max-width 100%
  overflow hidden
  text-overflow ellipsis
  white-space nowrap
  font-size 0.9em
  font-weight 600
  color FONT_COLOR

.dot
  flex none
  width 10px
  height 10px
  border-radius 50%

// À classer : pastille vide, à remplir en choisissant une intention. Interligne plus haut : le badge coupe ce qui dépasse, et l'accent de « À » dépasserait.
.unclassified
  line-height 1.5
  color CTRL_TEXT_MUTED

  .dot
    box-sizing border-box
    border 2px solid CTRL_TEXT_MUTED
    background transparent
</style>
